export const reInfoOrgConstructionMaterialPricesPerPeriodConstants = {
	GetPaged: {
		FAILURE : 'GET_PAGED_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_FAILURE',
		REQUEST : 'GET_PAGED_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_REQUEST',
		SUCCESS : 'GET_PAGED_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_SUCCESS'
	},
	GetPagedAudit: {
		REQUEST : 'GET_PAGED_AUDIT_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_FAILURE',
		SUCCESS : 'GET_PAGED_AUDIT_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_SUCCESS',
		CLEAR   : 'GET_PAGED_AUDIT_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_CLEAR'
	},
	Delete: {
		FAILURE : 'DELETE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_FAILURE',
		REQUEST : 'DELETE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_REQUEST',
		SUCCESS : 'DELETE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_SUCCESS'
	},
	DeleteSelectedPrices: {
		FAILURE : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	DeleteFilteredPrices: {
		FAILURE : 'DELETE_FILTERED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'DELETE_FILTERED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'DELETE_FILTERED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	Update: {
		FAILURE : 'UPDATE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_FAILURE',
		REQUEST : 'UPDATE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_REQUEST',
		SUCCESS : 'UPDATE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_SUCCESS'
	},
	GetFile: {
		FAILURE : 'GET_FILE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_FAILURE',
		REQUEST : 'GET_FILE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_REQUEST',
		SUCCESS : 'GET_FILE_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD_SUCCESS'
	},
	CLEAR: 'CLEAR_RE_INFO_ORG_CONSTRUCTION_MATERIAL_PRICES_PER_PERIOD'
}